<template>
  <div class="d-flex-column justify-start align-start gap-8">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">
        {{ $t("dungeon_type") }}
      </label>
      <ItemTooltip :text="$t('new.select_mythic_plus_dungeons')" />
    </div>
    <DropDown
      :drop-items="dungeonOptions"
      :select-drop-item="selectDungeon"
      :selected-item="checkoutStore.getPackExtraOptions?.dungeon"
      v-if="!$isMobile() && !$isTablet()"
    />

    <BSPicker
      v-else-if="$isMobile() || $isTablet()"
      :title="$t('dungeon_type')"
      :show-title="false"
      :items="dungeonOptions"
      item-key="id"
      :selected-item="checkoutStore.getPackExtraOptions?.dungeon"
      :select-filter="selectDungeon"
      :allow-null="false"
    />
  </div>
</template>

<script setup>
import DropDown from "~/components/custom/DropDown.vue";
import ItemTooltip from "../../fc-25/pickers/ItemTooltip.vue";
import BSPicker from "./BSPicker.vue";
const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();
const dungeonOptions = computed(() => {
  if (gameStore.getGamePack?.pack_extra_options) {
    return gameStore.getGamePack?.pack_extra_options
      ?.filter((opt) => opt.description === "dungeon")
      ?.reduce((accumulator, value) => {
        return {
          ...accumulator,
          [value.id]: `<span>${
            value.title
          }</span> <span class='t-blue text-capitalize'>${renderPrice(
            value
          )}</span>`,
        };
      }, {});
  }
  return [];
});

const selectDungeon = (key, value) => {
  checkoutStore.setPackExtraOptions({
    dungeon: parseInt(value),
  });
};
</script>
